import { ClientOnboardingDeliverableVariant } from './types';

export const DELIVERABLE_CARD_ORDER = [
  'GENERATE_ESTATE_SNAPSHOT',
  'BUILD_OUT_HOUSEHOLD',
  'CREATE_BALANCE_SHEET',
  'SUMMARIZE_DOCUMENT',
  'CREATE_ENTITY_OVERVIEW',
  'CREATE_ANALYSIS',
] as const;

export type DeliverableCardKey = (typeof DELIVERABLE_CARD_ORDER)[number];

export const DELIVERABLE_KEY_TO_VARIANT: Record<
  DeliverableCardKey,
  ClientOnboardingDeliverableVariant
> = {
  BUILD_OUT_HOUSEHOLD: ClientOnboardingDeliverableVariant.BUILD_OUT_HOUSEHOLD,
  CREATE_BALANCE_SHEET: ClientOnboardingDeliverableVariant.CREATE_BALANCE_SHEET,
  SUMMARIZE_DOCUMENT: ClientOnboardingDeliverableVariant.SUMMARIZE_DOCUMENT,
  CREATE_ENTITY_OVERVIEW:
    ClientOnboardingDeliverableVariant.CREATE_ENTITY_OVERVIEW,
  CREATE_ANALYSIS: ClientOnboardingDeliverableVariant.CREATE_ANALYSIS,
  GENERATE_ESTATE_SNAPSHOT:
    ClientOnboardingDeliverableVariant.GENERATE_ESTATE_SNAPSHOT,
};

// Common descriptions for client onboarding deliverables
// NOT NOTE NOTE: The copy on these is pretty specific; if made longer,
// it will break onto a new line and cause cards to be of different heights.
export const CLIENT_ONBOARDING_DESCRIPTIONS = {
  SUMMARIZE_DOCUMENTS: 'Create a detailed summary of any planning document',
  CREATE_BALANCE_SHEET:
    'Create a complete balance sheet with assets, liabilities and trusts',
  CREATE_ENTITY_OVERVIEW:
    'Create a visual overview of trusts and business entities',
  BUILD_OUT_HOUSEHOLD:
    'Create individuals, organizations, entities, and sub-trusts',
  CREATE_ANALYSIS: 'Calculate the impact of gifts, GRATs, CRTs, and CLTs',
  GENERATE_ESTATE_SNAPSHOT:
    "Create a holistic overview of the client's estate in minutes",
};
